<p class="rs-p-wp-fix"></p>
<rs-module-wrap id="rev_slider_6_1_wrapper" data-alias="Home-6" data-source="gallery" style="background:transparent;padding:0;">
    <rs-module id="rev_slider_6_1" style="display:none;" data-version="6.1.8">
       <rs-slides>
          <rs-slide data-key="rs-6" data-title="Slide" data-anim="ei:d;eo:d;s:1000;r:0;t:fade;sl:0;">
             <img alt="banner-img" src="./assets/revslider/assets/transparent.png" data-bg="c:#eff7ff;" class="rev-slidebg" data-no-retina>
<!--
             --><rs-layer
                id="slider-6-slide-6-layer-0"
                data-type="image"
                data-rsp_ch="on"
                data-xy="x:r;xo:-53px,-33px,-25px,-96px;yo:-27px,-17px,-6px,-6px;"
                data-text="w:normal;s:20,12,9,5;l:0,16,12,7;"
                data-dim="w:322px,206px,141px,86px;h:397px,254px,174px,107px;"
                data-vbility="t,f,t,t"
                data-basealign="slide"
                data-frame_0="y:-50,-32,-24,-14;"
                data-frame_1="st:250;sp:1000;sR:250;"
                data-frame_999="o:0;st:w;sR:7750;"
                data-loop_0="y:10px;"
                data-loop_999="y:-10px;sp:3000;e:Sine.easeInOut;yym:t;"
                style="z-index:11;"
             ><img alt="banner-img" src="./assets/revslider/assets/05s.png" width="354" height="437" data-no-retina>
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-1"
                data-type="image"
                data-rsp_ch="on"
                data-xy="x:r;xo:-153px,-97px,-72px,-34px;y:b;yo:4px,2px,45px,85px;"
                data-text="w:normal;s:20,12,9,5;l:0,16,12,7;"
                data-dim="w:480px,307px,200px,124px;h:525px,336px,219px,136px;"
                data-basealign="slide"
                data-frame_0="x:50,32,24,14;"
                data-frame_1="st:980;sp:1000;sR:980;"
                data-frame_999="o:0;st:w;sR:7020;"
                data-loop_0="y:-10px;"
                data-loop_999="y:10px;sp:3000;e:Sine.easeInOut;yym:t;"
                style="z-index:12;"
             ><img alt="banner-img" src="./assets/revslider/assets/06s.png" width="547" height="598" data-no-retina>
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-2"
                data-type="image"
                data-rsp_ch="on"
                data-xy="x:c,c,c,r;xo:180px,115px,111px,54px;y:b;yo:-106px,-67px,-35px,-26px;"
                data-text="w:normal;s:20,12,9,5;l:0,16,12,7;"
                data-dim="w:588px,376px,201px,155px;h:539px,344px,184px,142px;"
                data-basealign="slide"
                data-frame_0="y:50,32,24,14;"
                data-frame_1="sp:1000;"
                data-frame_999="o:0;st:w;sR:8000;"
                data-loop_0="x:10px;"
                data-loop_999="x:-10px;sp:3000;e:Sine.easeInOut;yym:t;"
                style="z-index:9;"
             ><img alt="banner-img" src="./assets/revslider/assets/07s.png" width="519" height="476" data-no-retina>
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-3"
                data-type="image"
                data-rsp_ch="on"
                data-xy="x:l,l,l,c;xo:145px,92px,87px,-86px;y:b;yo:-84px,-53px,-37px,-20px;"
                data-text="w:normal;s:20,12,9,5;l:0,16,12,7;"
                data-dim="w:538px,344px,207px,127px;h:402px,257px,154px,95px;"
                data-basealign="slide"
                data-frame_0="x:-50,-32,-24,-14;"
                data-frame_1="sp:1000;"
                data-frame_999="o:0;st:w;sR:8000;"
                data-loop_0="x:-10px;"
                data-loop_999="x:10px;sp:3000;e:Sine.easeInOut;yym:t;"
                style="z-index:8;"
             ><img alt="bannerimg" src="./assets/revslider/assets/08s.png" width="619" height="462" data-no-retina>
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-4"
                data-type="image"
                data-rsp_ch="on"
                data-xy="xo:-55px,-35px,-20px,-17px;y:b;yo:69px,44px,38px,67px;"
                data-text="w:normal;s:20,12,9,5;l:0,16,12,7;"
                data-dim="w:291px,186px,114px,70px;h:539px,344px,211px,130px;"
                data-basealign="slide"
                data-frame_0="x:-50,-32,-24,-14;"
                data-frame_1="st:990;sp:1000;sR:990;"
                data-frame_999="o:0;st:w;sR:7010;"
                data-loop_0="y:10px;"
                data-loop_999="y:-10px;sp:3000;e:Sine.easeInOut;yym:t;"
                style="z-index:13;"
             ><img alt="bannerimg" src="./assets/revslider/assets/09.png" width="268" height="496" data-no-retina>
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-6"
                data-type="image"
                data-rsp_ch="on"
                data-xy="xo:-56px,-35px,-20px,-110px;yo:-33px,-21px,-9px,-2px;"
                data-text="w:normal;s:20,12,9,5;l:0,16,12,7;"
                data-dim="w:326px,208px,140px,86px;h:403px,257px,173px,106px;"
                data-vbility="t,t,f,f"
                data-basealign="slide"
                data-frame_0="y:-50,-32,-24,-14;"
                data-frame_1="st:250;sp:1000;sR:250;"
                data-frame_999="o:0;st:w;sR:7750;"
                data-loop_0="y:-10px;"
                data-loop_999="y:10px;sp:3000;e:Sine.easeInOut;yym:t;"
                style="z-index:10;"
             ><img alt="bannerimg" src="./assets/revslider/assets/10.png" width="357" height="441" data-no-retina>
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-7"
                class="textgyreadventor"
                data-type="text"
                data-color="#142149"
                data-rsp_ch="on"
                data-xy="x:c;xo:0,0,0,5px;yo:160px,102px,63px,78px;"
                data-text="w:normal;s:60,38,45,36;l:70,44,55,45;a:center;"
                data-frame_0="rX:70deg;oZ:-50;"
                data-frame_1="oZ:-50;e:Power4.easeInOut;st:290;sp:1750;sR:290;"
                data-frame_999="o:0;st:w;sR:6960;"
                style="z-index:14;"
             ><b>Cloud Database</b> <br />
Management Systems
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-8"
                data-type="text"
                data-color="#5e7290"
                data-rsp_ch="on"
                data-xy="x:c;y:m;yo:-100px,-70px,-19px,-14px;"
                data-text="w:normal;s:16,14,14,13;l:26,24,24,24;a:center;"
                data-frame_0="rX:70deg;oZ:-50;"
                data-frame_1="oZ:-50;e:Power4.easeInOut;st:830;sp:1750;sR:830;"
                data-frame_999="o:0;st:w;sR:6420;"
                style="z-index:15;"
             >It is a long established fact that a reader will be distracted by the readable<br> content of a page when looking at its layout.
             </rs-layer><!--

             --><rs-layer
                id="slider-6-slide-6-layer-9"
                class="iq-btn-round iq-button rev-btn"
                data-type="button"
                data-rsp_ch="on"
                data-xy="x:c;y:m;yo:-10px,-6px,52px,66px;"
                data-text="w:normal;s:16,14,14,14;l:18,14,14,14;"
                data-dim="minh:0px,none,none,none;"
                data-padding="t:15,12,12,12;r:30;b:15,12,12,12;l:30;"
                data-border="bor:4px,4px,4px,4px;"
                data-frame_0="rX:70deg;oZ:-50;"
                data-frame_1="oZ:-50;e:Power4.easeInOut;st:1100;sp:1750;sR:1100;"
                data-frame_999="o:0;st:w;sR:6150;"
                data-frame_hover="bgc:#0d1e67;bor:4px,4px,4px,4px;sp:500ms;e:Power4.easeInOut;bri:120%;"
                style="z-index:16;background-color:#007aff;"
             >Read More
             </rs-layer><!--
-->                  </rs-slide>
       </rs-slides>
       <rs-progress class="rs-bottom" style="visibility: hidden !important;"></rs-progress>
    </rs-module>
<script>
if(typeof revslider_showDoubleJqueryError === "undefined") {
 function revslider_showDoubleJqueryError(sliderID) {
    var err = "<div class='rs_error_message_box'>";
    err += "<div class='rs_error_message_oops'>Oops...</div>";
    err += "<div class='rs_error_message_content'>";
    err += "You have some jquery.js library include that comes after the Slider Revolution files js inclusion.<br>";
    err += "To fix this, you can:<br>&nbsp;&nbsp;&nbsp; 1. Set 'Module General Options' -> 'Advanced' -> 'jQuery & OutPut Filters' -> 'Put JS to Body' to on";
    err += "<br>&nbsp;&nbsp;&nbsp; 2. Find the double jQuery.js inclusion and remove it";
    err += "</div>";
 err += "</div>";
    jQuery(sliderID).show().html(err);
 }
}
</script>
 </rs-module-wrap>
